import { Component, OnInit, ViewChild, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EFormService } from '../../e-form.service';
import * as _ from 'lodash';
import { EFormDataObject } from '../../e-formDataObject.model';
import { ErrorList } from '../../../controls/error-prompt/error-list.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../shared.service';
import { UserService } from '../../../user/user.service';
import { YearService } from '../../../year/year.service';
import { EForm } from '../../e-form.model';
import { EFormNotesComponent } from '../../e-form-notes/e-form-notes.component';
import { EFormInstance } from '../../e-form-instance.model';
import { GeneralConfirmationComponent } from '../../../controls/general-confirmation/general-confirmation.component';
import { LoginService } from '../../../../shared-modules/login/login.service';
import { EFormMarkSubmissionComponent } from '../../../../admin360/e-forms/e-form-submissions/e-form-mark-submission/e-form-mark-submission.component';
import { EFormConfiguration, enmEFormViewModes } from '../../e-form-config.model';
import { EFormViewerComponent } from '../e-form-viewer.component';
import * as moment from 'moment';
import { SpinnerService } from '../../../spinner/spinner.service';
import { EFormChangeHistory } from '../../e-form-change-history.model';
import { TylTranslation } from '../../../models/tyl-translation.model';
import { TranslationService } from '../../../translation/translation.service';
import { EFormControl } from '../../e-form-control.model';
import { EFormSurveyAnswer } from '../../e-form-survey-answer.model';
import { take } from 'rxjs/operators';
import { EFormPdfNameComponent } from '../../../../admin360/e-forms/e-form-submissions/e-Form-PDF-Name/e-form-pdf-name.component';
import { EFormAttachment } from '../../e-form-attachment.model';
import { CustomizationFrameworkService } from '../../../../shared-modules/customization-framework/customization-framework.service';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-e-form-viewer-modal',
    templateUrl: './e-form-viewer-modal.component.html',
    styleUrls: ['./e-form-viewer-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class EFormViewerModalComponent implements OnInit, OnDestroy {

    @ViewChild(EFormViewerComponent, { static: true }) eFormViewer: EFormViewerComponent;
    eFormData: EFormDataObject;
    selectedForm: EForm;
    selectedInstance: EFormInstance;
    config = new EFormConfiguration();
    changes: EFormChangeHistory[];

    errors: ErrorList[] = [];

    isPreview = false;
    isReview = false;
    editable = true;
    showNextPreviousButtons = false;
    isLP = true;
    isFP = true;

    V10 = false;


    subscriptions: Subscription[] = [];

    translations: TylTranslation[] = [];

    constructor(
        private dialogRef: MatDialogRef<EFormViewerModalComponent>,
        private eFormService: EFormService,
        private sharedService: SharedService,
        private userService: UserService,
        private yearService: YearService,
        private loginService: LoginService,
        private spinnerService: SpinnerService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private customizationFrameworkService: CustomizationFrameworkService
    ) {
        this.V10 = this.loginService.LoginSettings.V10;

        if (data) {
            if (data.config) {
                this.config = data.config;
            }
            if (data.changes) {
                this.changes = data.changes;
            }
        }
        if (this.config.ViewMode == enmEFormViewModes.Template) {
            this.isPreview = true;
            this.editable = true;
            // this.disableMergeFields = true;
        }
        else if (this.config.ViewMode == enmEFormViewModes.Instance) {
            this.isPreview = true;
            this.editable = false;
            // this.disableMergeFields = true;
        }
        else if (this.config.ViewMode == enmEFormViewModes.Review) {
            this.editable = false;
            this.isReview = true;
        }
        else if (this.config.ViewMode == enmEFormViewModes.Page || this.config.ViewMode == enmEFormViewModes.CustomPage || this.config.ViewMode == enmEFormViewModes.FRMA) {
            this.editable = true;
            this.isPreview = true;
            this.config.IsPreview = true;
        }

        if (this.config.ReadOnly) {
            this.editable = false;
        }

    }

    ngOnInit() {
        this.selectedForm = _.cloneDeep(this.eFormService.selectedForm);
        this.eFormData = _.cloneDeep(this.eFormService.selectedFormData);
        this.eFormService.pdfDataURIs = [];
        this.eFormService.showCriticalMessage = false;

        if (this.eFormData.Tabs.length > 1 || this.eFormData.Tabs[0].Pages.length > 1) {
            this.showNextPreviousButtons = true;
        }

        if (!this.isPreview) {
            this.getInstance();
        }

        this.subscriptions.push(this.eFormService.observableIsFirstPageStream$.subscribe(isFirstPage => {
            this.isFP = isFirstPage;
        }));
        this.subscriptions.push(this.eFormService.observableIsLastPageStream$.subscribe(isLastPage => {
            this.isLP = isLastPage;
        }));
    }

    ngOnDestroy() {

    }

    getInstance() {
        this.subscriptions.push(this.eFormService.getEFormInstance(this.selectedForm.Instance_ID).subscribe(instance => {
            this.selectedInstance = instance;
        }));
    }

    acceptClick() {
        // if(this.V10) {
        this.selectedForm.Status = 'Accepted';

        if (this.selectedInstance.StoreLocation.toLowerCase() != 'eform' && (this.selectedInstance.FormDocTypeId || this.V10)) {
            this.eFormService.eFormAttachmentForPDF = [];
            // Check that attachments are user submitted attachments, not form images or links
            this.eFormService.allFormControls.forEach(control => {
                if (control.AttachmentId && control.ControlType == 'attachment') {
                    if (control.Attachment) {
                        this.eFormService.eFormAttachmentForPDF.push(control.Attachment);
                    }
                    else {
                        this.eFormService.getEFormAttachment(control.AttachmentId).subscribe(attachment => {
                            if (attachment) {
                                this.eFormService.eFormAttachmentForPDF.push(attachment);
                            }
                            else {
                                control.Attachment = new EFormAttachment();
                            }
                        });
                    }
                }
            });
            if (this.selectedInstance.AllowMultiple) {
                const PDFNameDialog = this.dialog.open(EFormPdfNameComponent, {
                    disableClose: true,
                    data: {
                        PDFName: this.selectedInstance.Name
                    }
                });
                PDFNameDialog.afterClosed().subscribe((PDFName: string) => {
                    this.selectedForm.PDFNameOverride = PDFName;
                    this.eFormViewer.initGenerateEnglishPDFOnly(() => {
                        this.selectedForm.EnglishPDF = this.eFormService.selectedForm.EnglishPDF;
                        this.saveAcceptedForm();
                    });
                });
            }
            else {
                this.eFormViewer.initGenerateEnglishPDFOnly(() => {
                    this.selectedForm.EnglishPDF = this.eFormService.selectedForm.EnglishPDF;
                    this.saveAcceptedForm();
                });
            }
        }
        else {
            this.saveAcceptedForm();
        }
    }

    saveAcceptedForm() {
        this.selectedForm.DatabaseFields = this.eFormService.getLinkedDBFields(this.eFormViewer.eFormData);
        this.customizationFrameworkService.getLinkedCustomFields(this.eFormViewer.eFormData, this.eFormViewer.selectedForm).pipe(take(1)).subscribe(customFields => {
            this.selectedForm.CustomFields = customFields;
            this.subscriptions.push(this.eFormService.saveEForm(this.selectedForm, '', false, this.getSiteYearId()).subscribe(result => {
                if (result) {
                    this.dialogRef.close('accept');
                }
                else {
                    this.sharedService.showBadSnackbar();
                }
            }));

            this.customizationFrameworkService.saveAllCustomFieldsInMemory();
        });
    }

    getSiteYearId(): number {
        let siteYearId = -1;
        if (this.selectedForm.TemplateType == 'student' && this.eFormViewer && this.eFormViewer.studentHeader) {
            siteYearId = this.eFormViewer.studentHeader.studentEnrollment.SiteYearId;
        }
        return siteYearId;
    }

    async printClick() {
        //  Initialize pdf
        this.eFormService.pdfDataURIs = [];

        this.eFormViewer.localPrint = true;
        this.eFormViewer.showAllConditionalsPrint = true;
        this.eFormViewer.addFormToPDFStarted = false;
        this.eFormViewer.columnInitializedBuffer = false;

        this.eFormViewer.showPrintDiv = true;
        this.spinnerService.showSpinner = true;
    }

    rejectClick() {
        this.selectedForm.Status = 'Rejected';
        const markCompleteDialog = this.dialog.open(EFormMarkSubmissionComponent, {
            disableClose: true,
            data: {
                markType: 'Rejected',
                eForm: this.selectedForm
            }
        });
        markCompleteDialog.afterClosed().subscribe((SendMail: string) => {
            if (SendMail) {
                this.selectedForm.Status = 'Rejected';
                this.selectedForm.TranslatedPDF = null;
                this.selectedForm.DocToFamily_ID = null;
                this.selectedForm.EnglishJSON = null;
                this.subscriptions.push(this.eFormService.saveEForm(this.selectedForm, '').subscribe(result => {
                    if (result) {
                        this.dialogRef.close(SendMail);
                    }
                    else {
                        this.sharedService.showBadSnackbar();
                    }
                }));
            }
        });


    }

    previousClick() {
        this.eFormViewer.previousClick();
    }

    nextClick() {
        this.eFormViewer.nextClick();
    }

    /// ************************************* Single Saving code **********************************************

    submitClick(methodName: string) {
        if (methodName == 'Submit') {
            this.errors = this.eFormViewer.validatePage();
        }
        if (methodName == 'SubmitLater') {
            this.errors = this.eFormViewer.validatePage(true);
        }
        if (this.eFormViewer.errors.length == 0) {
            this.eFormService.CheckEformsStatus(this.selectedForm.ID, this.selectedForm.Instance_ID, this.selectedForm.Student_ID, this.selectedForm.ParentMem_ID, this.loginService.LoginSettings.V10 ? this.selectedForm.PrimaryParentMem_ID : 0).subscribe(result => {
                if (result) {
                    const eForm: EForm = result;
                    let notPreviouslySubmitted: boolean = !eForm.Status
                        || eForm.Status.toLowerCase() == 'not submitted'
                        || eForm.Status.toLowerCase() == 'rejected';

                    if (!notPreviouslySubmitted && this.selectedForm.CompletionDue && this.selectedForm.CompletionDueOption == 'OncePer' && this.selectedForm.Frequency == 'Day') {
                        if (this.V10) {
                            if (moment(moment(eForm.SubmittedDate).format('MM/DD/YYYY')).isBefore(moment().format('MM/DD/YYYY'))) {
                                notPreviouslySubmitted = true;
                            }
                        }
                        else {
                            if (moment(moment(eForm.SubmittedOn).format('MM/DD/YYYY')).isBefore(moment().format('MM/DD/YYYY'))) {
                                notPreviouslySubmitted = true;
                            }
                        }
                    }

                    if (methodName == 'Submit' && (notPreviouslySubmitted || this.selectedInstance.AllowMultiple)) {
                        this.confirmSubmission();
                    }
                    else if (methodName == 'SubmitLater' && (notPreviouslySubmitted || this.selectedInstance.AllowMultiple)) {
                        this.selectedForm.Status = 'Not Submitted';
                        this.updateAttachments(false);
                        this.eFormService.templateProcessType = '';
                        this.eFormService.categoryType = '';
                    }
                    else {
                        this.submittedWarningMessage(eForm);
                    }
                }
            });
        }
    }

    confirmSubmission() {
        if (this.eFormViewer.errors.length == 0) {
            const submitConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
                width: '400px',
                disableClose: true,
            });
            submitConfirmDialog.componentInstance.headerLabel = 'Confirm Submit';
            submitConfirmDialog.componentInstance.confirmMessage = 'This e-Form will not be editable after it has been submitted.';
            submitConfirmDialog.componentInstance.secondMessage = 'If you are sure you do not need to make any more changes select OK. Otherwise, select Cancel.';
            submitConfirmDialog.componentInstance.confirmEvent.subscribe((confirm: boolean) => {
                if (confirm) {
                    this.submitEFormFor();
                }
            });
        }
    }

    submittedWarningMessage(eForm: EForm) {
        let messageText = '';

        if (eForm.SubmittedByName && eForm.SubmittedDate) {
            const submittedDate = moment(eForm.SubmittedDate).format('MM/DD/YYYY');
            const submittedTime = moment(eForm.SubmittedDate).format('hh:mm A');
            messageText = 'This form has already been submitted by ' + eForm.SubmittedByName + ' at ' + submittedTime + ' on ' + submittedDate + ' and cannot be submitted again.';
        }
        else {
            messageText = 'This form has already been submitted and cannot be submitted again.';
        }

        const alreadySubmittedDialog = this.dialog.open(GeneralConfirmationComponent, {
            disableClose: true,
        });
        alreadySubmittedDialog.componentInstance.informational = true;
        alreadySubmittedDialog.componentInstance.headerLabel = 'SUBMISSION DENIED';
        alreadySubmittedDialog.componentInstance.confirmMessage = messageText;
        alreadySubmittedDialog.afterClosed().subscribe((updateRequired: boolean) => {
            this.dialogRef.close('cancel');
        });
    }

    async submitEFormFor() {
        this.subscriptions.push(this.eFormService.getEformCategoryByInstanceId(this.selectedInstance.ID).subscribe(category => {
            this.selectedForm.Status = 'Submitted';
            this.selectedForm.SubmittedBy = this.userService.currentUser.Id;
            this.selectedForm.SubmittedOn = new Date();

            if (this.selectedForm.IsSurvey && this.selectedForm.DisplayCriticalMessage) {
                this.checkForCriticalMessage();
            }

            if (this.selectedInstance && this.selectedInstance.ProcessType.toLowerCase() == 'auto') {
                this.eFormService.templateProcessType = 'auto';
            }
            else {
                this.eFormService.templateProcessType = 'required';
            }

            if (category.CompletionMethod.toLowerCase() == 'auto') {
                this.eFormService.categoryType = 'complete';
            }
            else {
                this.eFormService.categoryType = 'accepted';
            }
            this.updateAttachments(true);
        })
        );
    }

    async saveEFormData(isSubmit: boolean) {
        this.selectedForm.FormData = JSON.stringify(this.eFormViewer.eFormData);
        this.selectedForm.Year_ID = (!this.selectedForm.Year_ID || this.selectedForm.Year_ID == undefined) ? this.yearService.student360Year.Id : this.selectedForm.Year_ID;

        this.eFormViewer.initGenerateEFormPDFAndJSON(this.selectedForm.Status, () => {
            if (this.selectedForm.Status.toLowerCase() == 'submitted' || this.selectedForm.Status.toLowerCase() == 'accepted') {
                if (this.selectedInstance.StoreLocation.toLowerCase() != 'eform' && (this.selectedInstance.FormDocTypeId || this.V10) && this.selectedInstance.ProcessType == 'auto') {
                    this.selectedForm.EnglishPDF = this.eFormService.selectedForm.EnglishPDF;
                }
                this.selectedForm.TranslatedPDF = this.eFormService.selectedForm.TranslatedPDF;
                this.selectedForm.EnglishJSON = this.eFormService.selectedForm.EnglishJSON;
                this.selectedForm.Non_English = this.userService.currentLanguage != 'en';
                this.selectedForm.DatabaseFields = this.eFormService.getLinkedDBFields(this.eFormViewer.eFormData);
                if (this.selectedForm.IsSurvey) {
                    this.selectedForm.SurveyAnswers = this.getSurveyAnswers();
                }
                this.eFormViewer.clearAttachments();
            }
            this.customizationFrameworkService.getLinkedCustomFields(this.eFormViewer.eFormData, this.eFormViewer.selectedForm).pipe(take(1)).subscribe(customFields => {
                this.selectedForm.CustomFields = customFields;
                this.subscriptions.push(this.eFormService.saveEForm(this.selectedForm, '', false, this.getSiteYearId()).subscribe(result => {
                    if (result) {
                        // ONE-8480
                        // If FromData is blank in EFM_Forms table
                        if (result.FormData == undefined || result.FormData == null || result.FormData == '' || result.FormData == 'null') {
                            this.sharedService.showBadSnackbar();
                        }
                        else {
                            this.dialogRef.close('save');
                        }
                    }
                    else {
                        this.sharedService.showBadSnackbar();
                    }
                })
                );
            });

        });
    }

    /// ***********************************************************************************************************************

    async updateAttachments(isSubmit: boolean = false) {
        this.eFormViewer.updateAttachments(() => {
            if (isSubmit) {
                this.eFormService.eFormAttachmentForPDF = [];
                // Check that attachments are user submitted attachments, not form images or links
                this.eFormService.allFormControls.forEach(control => {
                    if (control.AttachmentId && control.ControlType == 'attachment') {
                        this.eFormService.eFormAttachmentForPDF.push(control.Attachment);
                    }
                });
            }
            this.eFormViewer.clearAttachments();
            this.saveEFormData(isSubmit);
        });
    }

    // deprecated
    // updateDBFields(formID: number) {
    //     const dbFields = this.eFormService.getLinkedDBFields(this.eFormViewer.eFormData);
    //     if (dbFields.length > 0) {
    //         this.eFormService.updateLinkedDBFields(formID, dbFields).subscribe(success => {
    //             if (success) {
    //                 this.dialogRef.close('save');
    //             }
    //             else {
    //                 this.sharedService.showBadSnackbar();
    //             }
    //         });
    //     }
    //     else {
    //         if (this.V10) {
    //             if (this.selectedInstance.ProcessType.toLowerCase() != 'auto' || !this.selectedInstance.FormDocTypeId) {
    //                 if (this.userService.currentLanguage && this.userService.currentLanguage == 'en' || this.loginService.LoginSettings.V10) {
    //                     this.dialogRef.close('save');
    //                 }
    //             }
    //         }
    //         else {
    //             this.dialogRef.close('save');
    //         }
    //     }
    // }

    checkForCriticalMessage() {
        const surveyControls: EFormControl[] = this.eFormService.allFormControls.filter(control => control.IsCritical);

        this.eFormService.showCriticalMessage = false;

        surveyControls.forEach(control => {
            switch (control.ControlType) {
                case this.eFormService.controlTypes.checkbox:
                    if (control.Value == true) {
                        this.eFormService.showCriticalMessage = true;
                    }
                    break;
                default:
                    control.DropdownOptions.forEach(option => {
                        if (option.IsCritical && option.Code == control.Value) {
                            this.eFormService.showCriticalMessage = true;
                        }
                    });
                    break;
            }
        });
    }

    // deprecated
    saveSurveyAnswers() {
        const surveyControls: EFormControl[] = this.eFormService.allFormControls.filter(control => control.SurveyFieldID && control.SurveyFieldID > 0);

        if (surveyControls.length > 0) {
            const surveyAnswers: EFormSurveyAnswer[] = [];

            surveyControls.forEach(control => {
                const surveyAnswer: EFormSurveyAnswer = new EFormSurveyAnswer;
                surveyAnswer.ID = 0;
                surveyAnswer.FormID = this.selectedForm.ID;
                if (control.ControlType == this.eFormService.controlTypes.checkbox) {
                    surveyAnswer.Answer = control.Value == true ? 'checked' : 'unchecked';
                }
                else {
                    surveyAnswer.Answer = control.Value;
                }
                surveyAnswer.SurveyFieldID = control.SurveyFieldID;
                surveyAnswers.push(surveyAnswer);
            });

            this.eFormService.saveEFormSurveyAnswers(surveyAnswers).pipe(take(1)).subscribe(() => { });
        }
    }

    getSurveyAnswers(): EFormSurveyAnswer[] {
        const surveyControls: EFormControl[] = this.eFormService.allFormControls.filter(control => control.SurveyFieldID && control.SurveyFieldID > 0);
        const surveyAnswers: EFormSurveyAnswer[] = [];

        if (surveyControls.length > 0) {
            surveyControls.forEach(control => {
                const surveyAnswer: EFormSurveyAnswer = new EFormSurveyAnswer;
                surveyAnswer.ID = 0;
                surveyAnswer.FormID = this.selectedForm.ID;
                if (control.ControlType == this.eFormService.controlTypes.checkbox) {
                    surveyAnswer.Answer = control.Value == true ? 'checked' : 'unchecked';
                }
                else {
                    surveyAnswer.Answer = control.Value;
                }
                surveyAnswer.SurveyFieldID = control.SurveyFieldID;
                surveyAnswers.push(surveyAnswer);
            });
        }

        return surveyAnswers;
    }

    notesClick() {
        const noteDialog = this.dialog.open(EFormNotesComponent, {
            disableClose: true,
            data: {
                eForm: this.selectedForm
            }
        });
        this.subscriptions.push(noteDialog.afterClosed().subscribe(frm => {
            if (frm) {
                this.selectedForm = frm;
            }
        }));
    }

    cancelClick() {
        this.dialogRef.close('cancel');
    }
}
